export enum TriggerEnum {
    CameraZoom = 'camera-zoom',
    CameraRotate = 'camera-rotate',
    CameraPan = 'camera-pan',
    NodeSelection = 'node-selection'
}
